module.exports = __webpack_public_path__ + "img/forum-bytecookie.a0e885f2.svg";